import React from 'react';
interface Metric {
  label: string;
  value: string;
  trend?: string;
}
const metrics: Metric[] = [{
  label: 'Total Assets',
  value: '$1,240,500',
  trend: '+12%'
}, {
  label: 'Monthly Savings',
  value: '$4,200',
  trend: '+5%'
}, {
  label: 'Investment Return',
  value: '8.4%',
  trend: '-0.2%'
}, {
  label: 'Years to Goal',
  value: '12.5',
  trend: '-1.5'
}];
export function MetricsGrid() {
  return <section className="w-full border-t border-b border-[var(--color-swiss-gray)]" data-id="element-164">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 divide-y sm:divide-y-0 sm:divide-x divide-[var(--color-swiss-gray)]" data-id="element-165">
        {metrics.map((metric, index) => <div key={index} className="p-8 md:p-12 flex flex-col justify-between h-48 group hover:bg-gray-50 transition-colors duration-300" data-id="element-166">
            <span className="text-xs uppercase tracking-widest text-gray-500 font-medium mb-4" data-id="element-167">
              {metric.label}
            </span>
            <div className="flex items-baseline gap-4" data-id="element-168">
              <span className="text-4xl md:text-5xl font-bold tracking-tight text-black" data-id="element-169">
                {metric.value}
              </span>
              {metric.trend && <span className={`text-sm font-medium ${metric.trend.startsWith('+') ? 'text-green-600' : 'text-gray-400'}`} data-id="element-170">
                  {metric.trend}
                </span>}
            </div>
          </div>)}
      </div>
    </section>;
}